<div class="modal-header">
  <h4 class="modal-title h5" translate>Download configuration</h4>
  <button type="button" class="close" aria-label="Close" (click)="onClose()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<!--DOWNLOAD-->
<div class="modal-body">
  <div>
    <label for="configPath">
      <span translate>Select configuration:</span>
      @if (isLoadingCPOnes) {
        <span class="fa-solid fa-spinner fa-spin ml-2"></span>
      }
    </label>

    <ng-select name="configPath" id="configPath" title="Choose a gateway" [disabled]="isLoadingCPOnes"
      [items]="cloudplugOnes" bindLabel="name" bindValue="configPath" [(ngModel)]="selectedPath"
      placeholder="{{'Select or search a gateway' | translate}}">
      <ng-template ng-option-tmp let-item="item">
        <div><span [innerText]="item.name"></span></div>
        <small><span translate>Machine</span>: <span [innerText]="item.machineName"></span></small>
      </ng-template>
    </ng-select>
  </div>

  <p>
    <span translate>Do you really want to download configuration to </span>
    <strong [innerText]="gateway.name"></strong>?
  </p>
</div>

<!--FOOTER-->
<scitis-modal-footer [okButtonText]="okButtonText" [disableOkButton]="!selectedPath"
  (cancelButtonPressed)="onCancel($event)"
  (okButtonPressed)="onOk($event)">
</scitis-modal-footer>